import React, { useEffect, useState } from "react";
import Footer from "../../../../Kryzen Alpha App/Components/Footer/footer";
import performRequest from "../../../../Kryzen Alpha App/api/request";
import { Toast } from "../../../../Kryzen Alpha App/CustomComponent/toast";
import { useSelector } from "react-redux";
import DynamicFilterInput from "../../../../Kryzen Alpha App/Components/layouts/filter.inpit";
import getFilteredURL from "../../../../Kryzen Alpha App/Components/Functions/filters.getUrl";
import Pagination from "../../../Components/layouts/pagination";
import { FcBusinessman, FcFilmReel, FcSelfServiceKiosk } from "react-icons/fc";
import { BsBoxArrowInDownRight } from "react-icons/bs";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import StepRoutes from "../../../Routes/steps_routes";
import CourceTable from "./topic_details_table";
import CustomSelect from "../../../CustomComponent/custom_select";
import CustomInput from "../../../CustomComponent/custom_input";
import { Form, Formik } from "formik";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import { courceNewInfo } from "../../../SchemaInfo/info";
import { courcenewSchema } from "../../../Schemas/Media And Marketing/courseNewAdd.schema";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import { useNavigate } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import CourceNameTable from "./course_names_table";

const CourceNameDetails = () => {
  const user = useSelector((store) => store.login.user);
  const [refresh, setRefresh] = useState(false);
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    courceName: "",
    topicName: "",
  });
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    performRequest("GET", getFilteredURL("/cource/get-all-info", page, filters))
      .then((res) => {
        if (res.status === 200) {
          setData(res.data?.courceData);
          setTotalPages(Math.ceil(res.data?.totalCount / 50));
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [refresh, page]);

  const handelSubmit = (values, { resetForm }) => {
    // console.log("values are", values);
    performRequest("POST", `/cource/added-cource`, values)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Course created successfully!");

          /* CLOSE MODAL */
          const modal = document.getElementById("closeCourseModel");
          if (modal) modal.click();

          resetForm();

          // navigate(`/course`);
        } else {
          Toast("error", "Error while creating course details");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcSelfServiceKiosk className="fs-2 me-1" /> Cources
                </h2>
                <h4 className="text-muted">
                  <StepRoutes></StepRoutes>
                </h4>
              </div>
              <div className="col-md-4 d-none d-sm-block">
                <div className="btn-list justify-content-end">
                  <button
                    className="btn btn-primary me-2"
                    data-bs-toggle="modal"
                    data-bs-target="#modal-course"
                  >
                    {/* <TbAdjustmentsCheck className="me-1" /> */}
                    <BsBoxArrowInDownRight className="me-2 fs-2" />
                    ADD NEW COURSE
                  </button>
                  <a href={"/course"}>
                    <button className="btn btn-primary">
                      <BsBoxArrowInDownRight className="me-2 fs-2" />
                      ALL TOPICS
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-2 ">
                <div
                  id="faq-1"
                  className="accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div>
                    <div className="accordion-header m-0" role="tab">
                      <button
                        className="accordion-button fs-3 d-md-none p-0 "
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-1-1"
                      >
                        <h3 className="m-1">Filter result</h3>
                      </button>
                    </div>

                    <div
                      id="faq-1-1"
                      className="accordion-collapse collapse d-md-none"
                      role="tabpanel"
                      data-bs-parent="#faq-1"
                    >
                      <div className={`accordion-body pt-0`}>
                        <div className="row">
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Start Date:"
                              value={filters.startdate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  startdate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>
                          <div className="col-12">
                            <DynamicFilterInput
                              label="End Date:"
                              value={filters.enddate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  enddate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>

                          <div className="col-12">
                            <DynamicFilterInput
                              label="Course Name:"
                              value={filters.courceName}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  courceName: e.target.value,
                                })
                              }
                              type="text"
                              placeholder="Course Name"
                            />
                          </div>

                          <div className="col-12">
                            <div className="row mt-2">
                              <div className="col-6">
                                <button
                                  onClick={() => setRefresh(!refresh)}
                                  className="btn btn-success w-100"
                                >
                                  Apply Filter
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setFilters({
                                      courceName: "",
                                      startdate: "",
                                      enddate: "",
                                    });
                                    setPage(1);
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-secondary w-100"
                                >
                                  Reset Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-body d-none d-md-block ">
                      <div className="row">
                        <h3>Filter result</h3>
                        <div className="col-12">
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Start Date:"
                              value={filters.startdate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  startdate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>
                          <div className="col-12">
                            <DynamicFilterInput
                              label="End Date:"
                              value={filters.enddate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  enddate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Course Name:"
                              value={filters.courceName}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  courceName: e.target.value,
                                })
                              }
                              type="text"
                              placeholder="Course Name"
                            />
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="row mt-2">
                            <div className="col-6">
                              <button
                                onClick={() => setRefresh(!refresh)}
                                className="btn btn-success w-100"
                              >
                                Apply Filter
                              </button>
                            </div>
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  setFilters({
                                    courceName: "",
                                    startdate: "",
                                    enddate: "",
                                  });
                                  setPage(1);
                                  setRefresh(!refresh);
                                }}
                                className="btn btn-secondary w-100"
                              >
                                Reset Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                {data && (
                  <CourceNameTable
                    data={data}
                    currentPage={page}
                    itemsPerPage={50}
                  />
                )}

                <div className="btn-list justify-content-center">
                  <div className="d-lg-none d-md-none mt-3 mb-3">
                    <button
                      className="btn btn-primary me-2"
                      data-bs-toggle="modal"
                      data-bs-target="#modal-course"
                    >
                      {/* <TbAdjustmentsCheck className="me-1" /> */}
                      ADD NEW COURSE
                    </button>
                    <div>
                      <a href={"/course"}>
                        <button className="btn btn-primary">
                          <BsBoxArrowInDownRight className="me-2 fs-2" />
                          ALL TOPICS
                        </button>
                      </a>
                    </div>
                  </div>
                </div>

                <Pagination
                  page={page}
                  setPage={setPage}
                  totalPages={totalPages}
                  pageDatalength={data?.length}
                  showPage={showPage}
                  setShowPage={setShowPage}
                />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
      <div
        className="modal modal-blur fade"
        id="modal-course"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered w-lg-100 w-md-100">
          <div className="modal-dialog modal-dialog-centered w-100">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">ADD NEW COURSE</h5>
                <span
                  data-bs-toggle="modal"
                  data-bs-target="#modal-course"
                  id={"open-model"}
                ></span>
                <button
                  type="button"
                  id="closeCourseModel"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <Formik
                initialValues={courceNewInfo}
                validationSchema={courcenewSchema}
                onSubmit={handelSubmit}
              >
                {(props) => (
                  <Form>
                    <div className="modal-body">
                      <div>
                        <div className="row mb-3">
                          <label className="form-label required col-3">
                            Course Name
                          </label>
                          <div className="col-9">
                            <CustomInput name="courseName" type="text" />
                            {props?.touched?.courseName &&
                              props?.errors?.courseName && (
                                <p className="text-danger">
                                  {props?.errors?.courseName}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="row mb-3">
                          <label className="form-label col-3">
                            Course Description
                          </label>
                          <div className="col-9">
                            <CustomTextArea name="courseDes" type="text" />
                            {props?.touched?.courseDes &&
                              props?.errors?.courseDes && (
                                <p className="text-danger">
                                  {props?.errors?.courseDes}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="row mb-3">
                          <label className="form-label col-3">
                            ⁠Course first copy nas url
                          </label>
                          <div className="col-9">
                            <CustomInput name="courseUrl1" type="text" />
                            {props?.touched?.courseUrl1 &&
                              props?.errors?.courseUrl1 && (
                                <p className="text-danger">
                                  {props?.errors?.courseUrl1}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="row mb-3">
                          <label className="form-label col-3">
                            ⁠Course final url
                          </label>
                          <div className="col-9">
                            <CustomInput name="courseUrl2" type="text" />
                            {props?.touched?.courseUrl2 &&
                              props?.errors?.courseUrl2 && (
                                <p className="text-danger">
                                  {props?.errors?.courseUrl2}
                                </p>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer bg-transparent">
                      <button
                        type="button"
                        className="btn me-auto disable"
                        data-bs-dismiss="modal"
                        id="model-dismiss"
                      >
                        Close
                      </button>
                      <div className="btn-list justify-content-center">
                        <FormSubmitButton buttonText="Submit" />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourceNameDetails;
